import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // ✅ Correct
import "../styles/Header.css";

function Header() {
  const [username, setUsername] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        setUsername(decoded.email || "User");
      } catch (err) {
        console.error("Invalid token");
      }
    }
  }, []);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">GiftShop</Link>
        </div>
        <nav className="header-nav">
          {username ? (
            <span>Welcome, {username}</span>
          ) : (
            <Link to="/signin">Sign In</Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
